require('../bootstrap');
import * as func from '../functions';

$(document).ready(function () {
    const carPage = {
        isLoading: false,
        init() {
            $(document).on('click', '.car-show-phone-btn', this, this.showPhoneNumber);
            $(document).on('click', '.read-more-btn-car', this, function () {
                $(this).addClass('hide');
                $('.read-less-btn-car').removeClass('hide');
                $('.description-box').addClass('active');
            });
            $(document).on('click', '.read-less-btn-car', this, function () {
                $(this).addClass('hide');
                $('.read-more-btn-car').removeClass('hide');
                $('.description-box').removeClass('active');
            });
        },
        showPhoneNumber(event) {
            const _this = event.data;

            let id = $(this).data('id');
            let element = this;

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $("meta[name=csrf-token]").attr('content');
            values += '&id=' + id;

            $.ajax({
                type: "POST",
                url: `${baseURL}/vehicles/phone-number`,
                data: values,
                beforeSend: function () {
                    _this.isLoading = true;
                },
                complete: function () {
                    _this.isLoading = false;
                },
                success: function (response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 1) {
                        $('.car-show-phone-btn span').text(response.phone);
                        $(element).removeClass('car-show-phone-btn');
                        $(element).attr('href', 'tel:' + response.phone);
                    }
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        }
    };

    if ($('.car-page-container').length) {
        carPage.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/car-page.js